import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=6cebd88e&"
import script from "./IconButton.vue?vue&type=script&lang=js&"
export * from "./IconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cebd88e')) {
      api.createRecord('6cebd88e', component.options)
    } else {
      api.reload('6cebd88e', component.options)
    }
    module.hot.accept("./IconButton.vue?vue&type=template&id=6cebd88e&", function () {
      api.rerender('6cebd88e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/components/IconButton.vue"
export default component.exports